// @ts-check
"use strict";

import { memo } from "react"

import ReportView from "./ReportView";

import "./preview-report.css";

/**
 * @param {Object} props
 * @param {import(".").ReportData} props.reportData
 * @param {string} [props.blobImageUrl]
 * @param {string} [props.pdfHeightClass]
 */
export default function PreviewReport({
  reportData,
  blobImageUrl,
  pdfHeightClass = "",
}) {
  // All button logic has been moved to the main ChatReportPanel component

  return (
    <div className="chat-report__preview">
      <div className="chat-report__preview-viewer-wrapper">
        <MemoisedReportViewer
          reportData={reportData}
          blobImageUrl={blobImageUrl}
          pdfHeightClass={pdfHeightClass}
        />
      </div>
    </div>
  );
}

const MemoisedReportViewer = memo(
  /**
   * Memoised version of the ReportViewer to prevent flickering caused by rerenders
   * 
   * @param {Object} props
   * @param {import(".").ReportData} props.reportData
   * @param {string} [props.blobImageUrl]
   * @param {string} [props.pdfHeightClass]
   */
  function MemoisedReportViewer({ reportData, blobImageUrl, pdfHeightClass }) {
    return (
      <div
        className={`chat-report__preview-viewer ${pdfHeightClass}`}
        style={{ width: "100%", height: "100%", overflow: "auto" }}>
        <ReportView 
          blobImageUrl={blobImageUrl}
          reportData={reportData}
          rawReportJson={reportData?.rawReportJson}
        />
      </div>
    )
  },
  (prevProps, nextProps) => (
    Object.is(prevProps.reportData, nextProps.reportData) &&
    Object.is(prevProps.blobImageUrl, nextProps.blobImageUrl) &&
    Object.is(prevProps.pdfHeightClass, nextProps.pdfHeightClass)
  )
)